<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPlanDeger from "@/models/StrPlanDeger";

export default {
  mixins: [Api, Sabit, StrPlanDeger],
  props: ["DonemId", "TabloId", "Tablodetayid", "Guncelleme","BirimId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TableData: [],
      DataUpdateAlt: null,
      Gosterge: null,
    };
  },
  component: {},

  watch: {
    Guncelleme() {
      this.Get();
    },
  },

  methods: {
    Get() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.TableData = [];

      let filtrele = "&DonemId=" + this.DonemId + "&TabloId=" + this.TabloId + "&Tablodetayid=" + this.Tablodetayid + "&BirimId=" + this.BirimId;
      this.ActionsFilterGet({ Service: "StrPlanDeger", Page: Page, Filter: filtrele }).then((res) => {
        this.TableData = res.Data[0];
        this.Page.PageDataSize = res.TotalCount;
      });
    },
  },

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>
    <table v-if="TableData" class="table table-striped table-bordered mb-0">
      <thead class="table-light">
        <tr>
          <th style="width:50%" scope="col">Göstergeye İlişkin Sapmanın Nedeni</th> <!-- İlgililik -->
          <th scope="col">Göstergeye İlişkin Alınacak Önlem</th> <!-- Etkinlik -->
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><div v-html="TableData.Ilgililik"></div></td>
          <td><div v-html="TableData.Etkililik"></div></td>
        </tr>
      </tbody>
    <!-- <thead class="table-light">
        <tr>
          <th style="width:50%" scope="col">Etkinlik</th>
          <th scope="col">Sürdürülebilirlik</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><div v-html="TableData.Etkinlik"></div></td>
          <td><div v-html="TableData.Surdurulebilirlik"></div></td>
        </tr>
      </tbody> --> 
    </table>
  </div>
</template>
